import { ALL_FUNCTIONS_GROUP, FUNCTION_CATEGORIES, FunctionFieldType, FunctionItem } from '@makyoapp/makyo-common'

import { CategoryState } from './types'

export function getDefaultCategory(activeValue?: FunctionItem): CategoryState {
  return activeValue
    ? {
        cat: activeValue.category,
        subCat: activeValue.subCategory,
      }
    : {
        cat: 'all',
        subCat: undefined,
      }
}

export function getCategoryItems(cat: CategoryState, fav: string[]) {
  if (cat.cat === 'all') {
    return ALL_FUNCTIONS_GROUP
  } else if (cat.cat === 'favorite') {
    return ALL_FUNCTIONS_GROUP.filter((f) => fav.includes(f.id))
  }

  if (cat.subCat) {
    if (cat.subCat === 'all') {
      return FUNCTION_CATEGORIES[cat.cat]?.items || []
    } else {
      return (FUNCTION_CATEGORIES[cat.cat]?.items || []).filter((i) => i.subCategory === cat.subCat)
    }
  } else {
    return FUNCTION_CATEGORIES[cat.cat]?.items || []
  }
}

export function getFnSyntax(fnItem: FunctionItem) {
  return fnItem.syntax
    ? fnItem.syntax
    : `${fnItem.title}(${fnItem.fields
        .filter((f) => {
          if (f.skip === true) {
            return false
          }

          return ![FunctionFieldType.Title, FunctionFieldType.Hr].includes(f.type)
        })
        .map((f) => {
          return f.multiple ||
            [FunctionFieldType.ColumnOrCustomMulti, FunctionFieldType.Ifs, FunctionFieldType.IfsThen].includes(f.type)
            ? `[...${f.id}]`
            : f.id
        })
        .join(', ')})`
}
